
import { cn } from "@/lib/utils";
import type { StatData } from "@/lib/data/stats";

interface StatsCardProps {
  stat: StatData;
}

export function StatsCard({ stat }: StatsCardProps) {
  return (
    <div className="flex min-w-0 flex-col items-center gap-0.5 px-1 text-center xl:flex-1 xl:px-0">
      {/* Number with colorful text */}
      <div
        className={cn(
          "whitespace-nowrap text-sm font-bold sm:text-base md:text-lg lg:text-xl",
          stat.colorClass,
          "dark:brightness-125"
        )}
      >
        {stat.value}
      </div>
      {/* Label text - Korean text with proper wrapping */}
      <div 
        className="w-full break-keep px-0.5 text-[8px] font-medium leading-tight text-gray-600 dark:text-gray-400 sm:text-[9px] md:text-[10px] lg:text-xs"
        style={{ wordBreak: 'keep-all', overflowWrap: 'break-word' }}
      >
        {stat.label}
      </div>
    </div>
  );
}

